import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import { isMovieSeries, isSpecial, truncateText } from 'helpers/ContentHelper';
import { useBoolean, useLockedBody, useBreakpoint } from 'hooks';
import Modal from '../Modal';
import Heading from '../Heading';
import Divider from '../Divider';
import SocialIcons from './components/SocialIcons';

import { makeSelectSeriesDetailSeriesData } from '../../selectors';

import Style from './AboutV2.module.scss';

const About = () => {
  const data = useSelector(makeSelectSeriesDetailSeriesData);
  const { name, description: shortDescription, longDescription, seriesType } = data;
  const { value: showModal, setTrue, setFalse } = useBoolean(false);
  const [locked, setLocked] = useLockedBody();
  const breakpoint = useBreakpoint();
  const modalRef = useRef();

  const {
    seriesDetail_aboutLabel: aboutLabel,
    seriesDetail_aboutTheShowLabel: aboutTheShowLabel,
    global_moreButton: moreButtonLabel,
  } = window.Language;

  const aboutHeaderText =
    isMovieSeries(seriesType) || isSpecial(seriesType) ? aboutLabel : aboutTheShowLabel;

  const maxChars = {
    [SITE_PLATFORM_WEB_LARGE]: 1400,
    [SITE_PLATFORM_WEB]: 700,
    [SITE_PLATFORM_TABLET]: 250,
    [SITE_PLATFORM_MOBILE]: 180,
  };

  const makeMaxChars = () => maxChars[breakpoint];
  const description = longDescription || shortDescription || '';
  const truncatedDescription = truncateText(description, makeMaxChars());
  const showButton = description.length > makeMaxChars();

  const handleOverlayClick = e => {
    const { id: refId } = modalRef.current;
    const { id: targetId } = e.target;
    if (refId === targetId) handleCloseModal();
  };

  const handleOpenModal = () => {
    setTrue();
    setLocked(!locked);
  };
  const handleCloseModal = () => {
    setFalse();
    setLocked(!locked);
  };

  const modalProps = {
    description: longDescription || shortDescription,
    handleOverlayClick,
    id: 'modal',
    modalRef,
    name,
    showModal,
  };

  return (
    <>
      <section className={Style.about}>
        <Heading title={aboutHeaderText} />
        <div className={Style.wrap}>
          <div className={Style.description}>
            <p>
              {truncatedDescription}
              {!showButton ? null : (
                <button
                  onClick={() => handleOpenModal()}
                  type="button"
                  aria-label={moreButtonLabel}
                >
                  {moreButtonLabel}
                </button>
              )}
            </p>
          </div>
          <SocialIcons />
        </div>
        <Modal handleCloseModal={handleCloseModal} {...modalProps} />
      </section>
      <Divider />
    </>
  );
};

export default About;
